import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { clearConsoleErrorBuffer } from '../lib/consoleErrorBuffer.js';
import { disconnectSocket } from '../lib/socket.js';

export const useAuth = create(
  persist(
    (set, get) => ({
      token: null,
      agent: null,
      tenant: null,
      isAuthed: () => !!get().token,
      setSession: (token, agent) => {
        // Drop the old realtime connection only when the IDENTITY changes (login /
        // account switch). setSession is also called to refresh the agent object
        // (wallet, onboarding…) — recycling the socket then would orphan every
        // mounted listener.
        if (token && token !== get().token) disconnectSocket();
        if (token) {
          try { localStorage.setItem('civix_token', token); } catch (e) { /* sandboxed iframe */ }
        }
        set({ token, agent });
      },
      setTenant: (tenant) => set({ tenant }),
      logout: () => {
        disconnectSocket();
        try { localStorage.removeItem('civix_token'); } catch (e) { /* ignore */ }
        try { clearConsoleErrorBuffer(); } catch (e) { /* ignore */ }
        set({ token: null, agent: null, tenant: null });
      },
      isAdmin: () => ['admin', 'superadmin'].includes(get().agent?.role),
      isSuperadmin: () => get().agent?.role === 'superadmin',
    }),
    { name: 'civix-auth', partialize: (s) => ({ token: s.token, agent: s.agent }) }
  )
);
